module.exports = __webpack_public_path__ + "img/icon-expand.2bf96c34.svg";